module.exports = __webpack_public_path__ + "static/media/logo.65a683fa.png";